import { useState, useRef, useEffect } from "react"; 
import HorizontalMenu from "./HorizontalMenu";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from "@mui/material";  
import { MainBg } from "./MainBg";
import { RepoItem } from "./RepoItem";
import { inputBgColor } from "./Scan";
import { FormControlLabel, Checkbox ,Input} from "@mui/material";

import { newSessionUID,getApplicationImage, APPFACTOR,capitalize } from "./commons";
import { ProxySettings, hv} from "./ScanSettingsPage";

import { isValidUrl } from "./newAppComponent";

const UID_CREATE = "10000024-f00d-face-abba-aabbbbaa";

function processCreation(event) {
  try{

    if(!window.createdDataSources) {
      window.createdDataSources = [];
    }
  
    let eventData = JSON.parse(event.data);
    
    if( window.createdDataSources.includes(eventData.id) ) {
      if(eventData.success === false) {
        console.log("setting error",eventData?.error || "Please verify data source configuration");
        window.setIndexSetError(eventData?.error || "Please verify data source configuration");
      }else{
        window.refreshDataSources();
        window.closeAddIndexPage();
      }

      
    }else 
     if(eventData?.id?.indexOf( UID_CREATE) == 0) {
      if(eventData.completed === true && eventData.success === true) {
        let newID = newSessionUID();
        window.createdDataSources.push(newID);
        let data = window.payloadData[eventData.id].payloadData;
  
        let payload = 
          {
            "type": "add_data_source",
            "id": newID,
            "data_source_name": data.name,
            "data_source_type": data.type,
            "base_url": data.url, 
            "http_client_settings": data.http_client_settings || null,
          }
        
          if(data.type === "gitlab") {
            payload.token_secret_ref = window.payloadData[eventData.id].payloadSecret.secret_key;
          } else{
            payload.credentials_secret_ref = window.payloadData[eventData.id].payloadSecret.secret_key;
          }
          
          // console.log("payload",payload);
      
          window.postMessage(
            JSON.stringify(
              {
                type: APPFACTOR.command,
                scanRaw: true,
                payload:
                {
                  ...payload
                }
              }
            )
          )
      }else{
        if(eventData.success === false) {
          console.log("setting error",eventData?.error || "Please verify data source configuration");
          window.setIndexSetError(eventData?.error || "Please verify data source configuration");
        }
      }
    } 
  }catch(e){
    /**/
  }
}


export default function ScanIndexPage({ title, isDarkMode, gdata, mData,setOpenAddIndexPage,openAddIndexPage, refreshDataSources,editDataSource, repoName }) {
  const [override, setOverride] = useState(false);
  const [activeTab, setActiveTab] = useState("disabled");


const [indexSetError, setIndexSetError] = useState(null);

  function createNewRepoItem(data) {
    window.refreshDataSources = refreshDataSources;
    window.setIndexSetError = setIndexSetError;
    window.closeAddIndexPage = () => {
      setOpenAddIndexPage(false);
      setCurrentItemData(prev => ({ type: prev.type, ...commonFields }));
      document.querySelectorAll("[id^='input_']").forEach(f => { f.value = ""; });
    };

    try{
      window.removeEventListener("message", processCreation, false);
    }catch(e){
      /**/
    }
  
    window.addEventListener("message", processCreation, false);
  
    if(!window.payloadData){
      window.payloadData = {};
    }
    
    let rndVal = (Math.floor(Math.random() * (9999 - 1000 + 1) + 1000));
    let rID = UID_CREATE + rndVal;
  
    let overrideData = {

    }

    if( override ) {
      if(activeTab == "disabled"){
        overrideData.http_client_settings = {
          "http_proxy": null,
        };
      }else{
        overrideData.http_client_settings = {
          "ignore_certificate_errors": false,
          "http_proxy": null,
          "http_proxy_auth_secret_ref": ""
        }
      }
    }

    window.payloadData[rID] = {
      payloadData: {
        ...data,
        ...overrideData
      },
      payloadSecret: {
        "type": "add_secret",
        "id": rID,
        "secret_key": (data.username||data.name) + "_secret" + rndVal,
        "secret": {
            "type": `username_password`,
            "user_name": data.username || "useru_lalilalilulu",
            "password": (data.token || data.password)
        }
      },
    };
  
       
      window.postMessage(
        JSON.stringify({
            type: APPFACTOR.command,
            scanRaw: true,
            payload:  window.payloadData[rID].payloadSecret
        })
      );

  }


  const commonFields ={
    name: "",
    // username: "",
    url: "",
  }

  const fieldsConfig = {
    gitlab: {
      type: "gitlab",
     ...commonFields,
     token: "",
    },
    artifactory: {
      type: "artifactory",
      ...commonFields,
      token: "",
    },
    servicenow: {
      type: "servicenow",
      name: "",
      url: "",
      username: "",
      password: "",
    },
    github: {
      type: "github",
      ...commonFields,
    }
  }


  const [currentItemData, setCurrentItemData] = useState(
    // window.editIndex || 
    {
    type: "gitlab",
    ...commonFields,
  });
  
  const activeFields = Object.keys(fieldsConfig[currentItemData.type]).filter((field) => field !== "type");

  let sizes ={
    width:777,
    height:777,
  }

  const buttonRef = useRef(null);

  return (
  <>
  <Dialog 
  keepMounted
  style={{
    padding: 0,
    margin: 0,
  }}
  slotProps={{
    paper: {
      sx: {
        color:isDarkMode ? "white" : "black",
        opacity: 1,
        padding: 0,
        margin: 0,
        minWidth: sizes.width,
        minHeight: sizes.height,
        background: "transparent !important"
      }
    }
  }}
  
  open={openAddIndexPage} 
  onClose={() => setOpenAddIndexPage(false)}>
    <div
    style={{
      zIndex: -1,
      position: "absolute",
      marginTop:-12,
      marginLeft:-26,
      width: sizes.width +26,
      height: sizes.height + 12,
      overflow:"hidden",
      background: "transparent !important"
    }}
    >
      
    <MainBg isDarkMode={isDarkMode } width={sizes.width + 50} height={sizes.height } ></MainBg>
    </div>
    
    <DialogTitle
    style={{
      paddingTop: 40,
      paddingLeft: 40,
      // margin: 0,
    }}
    >
      <div style={{
        fontSize: 16,
         marginTop: -14
         }}>
      {title?title:"Add custom data source"}
      </div>
      <div style={{
        fontSize: 13,
        opacity: 0.5,
         marginBottom: 32
         }}>
          Data source that will be indexed.
          </div>
      
    </DialogTitle>
    <DialogContent
     sx={{
      padding:0,
      paddingLeft: "40px",
      paddingRight: "40px",
      margin:0,
      maxWidth: "700px",
    }}
    >
<form>

<div style={{
  position: "absolute",
  display : "flex",
  top: 24,
  marginLeft: 294,
  paddingBottom: 20,
}}>
    {[
      // "github",
      "gitlab",
      "artifactory",
      "servicenow"
      ].map((type,index) => (TypeSelector (type,setCurrentItemData, currentItemData.type === type, index)))}
        </div>

      {indexSetError && <div style={{
          position: "absolute",
          marginTop: -8,
          fontSize: 11,
          width: "100%",
          height: 42,
          color: "red",
        }}>{indexSetError}</div>
      }

      {activeFields?.map((field,index) => (
        InputElement(
          field,
          isDarkMode,
          setCurrentItemData, 
          index==0,
          (index == activeFields.length-1) ? buttonRef : null,
          setIndexSetError, 
          editDataSource,repoName)
        ))}

        {/* <div
        style={{
          position: "absolute",
          marginTop: 84,
          marginLeft: 46,
          fontSize: 13,
          opacity: 0.5,
          overflow: "hidden",
        }}
        >Preview</div>

      <div style={{
        position: "absolute",
        marginTop: 20,
        marginLeft: 110,
        bottom: 151,
        width: "calc(100% - 220px)",
        height: "180px",
        overflow: "hidden",
      }}>
        <RepoItem 
         showIndexButton={false}
         m={currentItemData}
         i={0}
         isDarkMode={isDarkMode} />
      </div> */}



 <div style={{
  marginTop: 10,
  width: "calc(100% - 110px)",
  height: "180px",
  marginLeft: 60,
  // borderRadius: 8,
  padding: 10,
  paddingBottom: 30,
  borderTop: "1px solid rgba(128,128,128,0.12)",
}}>
  
  <FormControlLabel
                            style={{
                                marginTop: 0,
                                padding: 0,
                                marginBottom: 0,
                                marginLeft: 0,
                            }}
                            control={
                                <Checkbox
                                    {...(currentItemData?.keep_downloaded_scanner ? { checked: true } : {})}
                                    onChange={(e) => {

                                      setOverride(e.target.checked)
                                       
                                    }}
                                />
                            }
                            label="Override proxy"
                            slotProps={{
                                typography: {
                                    style: {
                                        color: isDarkMode ? "white" : "black",
                                        opacity: 0.5,
                                        fontSize: '13px'
                                    }
                                }
                            }}

                        />

      {override&& 
      <>
       <HorizontalMenu
                            addLabel={false}
                            noScale={true}
                            alignleft={true} 
                            value={activeTab}
                            setValue={setActiveTab}
                            
                        menuValues={["disabled",
                          // "proxy"
                        ]}
                        menuItems={[
                            <div
                              style={{ display: "inline-block" }}
                              onClick={() => {
                               
                              }}
                            >Disabled</div>
                          //   ,<div
                          //   style={{ display: "inline-block" }}
                          //   onClick={() => {
                             
                          //   }}
                          // >Proxy settings</div>
                        ]}

                        onChangeValue={(e, val) => {
                            if( val  ){
                                setActiveTab(val);
                            }
                        }}
                        />

      <div style={{
        // marginLeft: -110,
        marginLeft: 40,
        width: "calc(100% + 120px)",
        marginTop: 20,
        fontSize: 12,
        opacity: 0.5,
      }}>
        {/* {activeTab=="proxy"&& <ProxySettings isDarkMode={isDarkMode} />} */}
        <div>Global proxy disabled for this data source.</div>
        <div>Indexing of this data source will not use the global proxy.</div>
        </div>
        </>
        }


      </div>

      <div style={{
        position: "absolute",
        marginTop: 20,
        marginLeft: 210,
        bottom: -34,
        width: "calc(100% - 220px)",
        height: "180px",
        overflow: "hidden",
      }}>
      <Button
      id="button1"
      ref={buttonRef}
    style={{
      color: isDarkMode ? "rgba(255,255,255,0.75)" : "rgba(0,0,0,0.5)",
      fontSize: 14,
      marginTop: 24,
      // marginLeft:-86,
      maxWidth: 128,
      minWidth: 128,
      maxHeight: 32,
      minHeight: 22,
      padding: "4px !important",
      borderRadius: 4,
      border: isDarkMode ? "1px solid rgba(42,42,42,0)" : "1px solid rgba(0,0,0,0.142)",
    }}
    onClick={(event) => {
      setIndexSetError("")
      event.preventDefault();
      event.stopPropagation();

      let error = false;

      activeFields.forEach(field => {
        if(!currentItemData[field] || currentItemData[field].length === 0) {
          error = true;
          setIndexSetError(p=> ((p?(p+", "):"") + `Please enter a value for "` + capitalize(field) +`"` ));
          return;
        }

        if(field == "url" && !isValidUrl(currentItemData[field])) {
          error = true;
          setIndexSetError(p=> ((p?(p+", "):"") + `Please enter a valid URL for "` + capitalize(field) +`"` ));
        }
      });

      if(error == false) {
        window.addNewRepoItem = currentItemData;
        createNewRepoItem({...currentItemData});
      }

    }}>SAVE</Button>

    <Button
    style={{
      color: isDarkMode ? "rgba(255,255,255,0.75)" : "rgba(0,0,0,0.5)",
      fontSize: 14,
      marginTop: 24,
      marginLeft:20,
      maxWidth: 128,
      minWidth: 128,
      maxHeight: 32,
      minHeight: 22,
      padding: "4px !important",
      borderRadius: 4,
      border: isDarkMode ? "1px solid rgba(42,42,42,0)" : "1px solid rgba(0,0,0,0.142)",
    }}
    onClick={() => {
      setCurrentItemData(prev => ({ type: prev.type, ...commonFields }));
      document.querySelectorAll("[id^='input_']").forEach(f => { f.value = ""; });
      setOpenAddIndexPage(false);
    }}>CANCEL</Button>
    </div>
    </form>    
    </DialogContent>

  </Dialog>
  </>

)

  function TypeSelector(type,setType, active, index) {
    const [isSelected, setIsSelected] = useState(false);
    const [lastActiveElement, setLastActiveElement] = useState("input_name");
    return <div
    key={"ts-"+index}
    onMouseDown={() => {
      try{
        setLastActiveElement(document.activeElement.id);
      } catch (e) {
        /**/
      }
    }}
    onMouseEnter={() => {
      setIsSelected(true);
    }}
    onMouseLeave={() => {
      if(!isSelected) {
        return;
      }
      setIsSelected(false);
    }}
    style={{
      // filter: (active || isSelected )? "none" : "grayscale(100%)",
      transition: "all 0.2s ease-in-out",
      cursor: "pointer",
      scale: isSelected ? 1 : 0.8,
      width: "64px",
      height: "64px",
      borderRadius: 8,
      marginLeft:10,
      // position: "absolute",
      backgroundColor: isDarkMode ? "rgba(4,4,4,0)" : "rgba(224,224,224,1)",
      top: 14,
      left: 14,
      border: active ? "1.42px solid rgb(217, 28, 33)" : "1.42px solid rgba(255,255,255,0.10)",
    }}
    onClick={() => {
      setType(prev => {
        const template = fieldsConfig[type];
        const next = { type };
        Object.keys(template).forEach(field => {
          if(field === "type") return;
          next[field] = (field === "name" || field === "url") ? (prev[field] || "") : "";
        });
        return next;
      });

      try{
        document.getElementById(lastActiveElement).focus();
      } catch (e) {
        /**/
      }
    }}
    >

      <div
        className="arepoLink"
        style={{
          position: "absolute",
          marginTop: 6,
          marginLeft: 6,
          width: 50,
          height: 50,
          minWidth: 30,
          minHeight: 30,
          borderRadius: "99em",
          backgroundColor: isDarkMode ? "rgba(4,4,4,0)" : "rgba(24,24,24,1)",
          backgroundSize: "46px 46px",
          backgroundPosition: "2px 2px",
          backgroundRepeat: "no-repeat",
          fontSize: 10,
          color: "rgba(255,255,255,0.5)",
          backgroundImage: `url(${getApplicationImage(
            type, "AppComponent",
            isDarkMode
          )})`
        }}
      ></div>
      <div style={{
        position: "absolute",
        marginTop: 26,
        marginLeft: 0,
        bottom:-16,
        fontSize: 10,
        width: 64,
        textAlign:"center",
        height: 10,
        textDecoration: active ? "underline 1.42px solid rgb(217, 28, 33)" : "none",
        textTransform:"uppercase",
        }}>{type}</div>
    </div>;
  }

function InputElement( keyVal, isDarkMode, setCurrentItemData, focus,buttonRef, setIndexSetError) {

  return <div 
  key={"in_" + keyVal}
  style={{
    paddingTop: 20,
    paddingLeft: 20,
  }}>
    <div style={{
      textTransform: "capitalize",
      opacity: 0.5,
      textAlign: "right",
      fontSize: 13,
      display: "inline-block",
      minWidth: "80px",
    }}>{keyVal}&nbsp;</div>
    <input 
     autoComplete={'one-time-code'}
     id={"input_" + keyVal}
     {...(focus == true ? { autoFocus: true} : {})}
     onKeyDown={(e) => {
      if (e.key === "Enter") {
        e.preventDefault();
        e.stopPropagation();
        if(e.target?.value?.trim()?.length === 0) {
          setIndexSetError(`Please enter a value for "` + capitalize(keyVal) +`"`);
          return;
        }
        setCurrentItemData(prev => ({
          ...prev,
          [keyVal]: e.target.value,
        }) )

        try{
          if(buttonRef) {
            buttonRef.current.focus();
          } else {
            const input = e.target.parentNode.nextSibling.querySelector("input");
            input.focus()
          }
        } catch (err) {
        } 
      }
    }}
    type={(keyVal === "token"  || keyVal === "password") ? "password" : "text"} 
    placeholder={"Enter " + keyVal} style={{
      width: "calc(100% - 150px)",
      marginLeft: 10,
      height: hv,
      minHeight: hv,
      maxHeight: hv,
      outline: "none",
      backgroundColor: inputBgColor(isDarkMode),
      color: isDarkMode ? "white" : "black",
      border: "none",
      boxShadow: "none",
      borderRadius: 8,
      padding: 15,
    }}
    onChange={(e) => {
        setCurrentItemData(
          prev => ({
            ...prev,
            [keyVal]: e.target.value,
          }) )
        }} />


  </div>;
}
}


export { ScanIndexPage };